import { render, staticRenderFns } from "./RewardIcon.vue?vue&type=template&id=e9a48cb4&scoped=true&"
import script from "./RewardIcon.vue?vue&type=script&lang=ts&"
export * from "./RewardIcon.vue?vue&type=script&lang=ts&"
import style0 from "./RewardIcon.vue?vue&type=style&index=0&id=e9a48cb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a48cb4",
  null
  
)

export default component.exports